
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './sideber/Sidebar';
import Clients from './clients/Clients';
import Fournisseurs from './fournisseurs/Fournisseurs';

import LoginPage from './logine/LoginPage';
import ChequeForm from './cheque/ChequeForm';
import RegisterPage from './Registrer/RegisterPage';
import './App.css';
import PositionEditor from './positions/PositionEditor';

const Layout = ({ children }) => {
  const location = useLocation();
  const hideSidebarPages = ['/login', '/register'].includes(location.pathname);

  return (
    <div>
      {!hideSidebarPages && <Sidebar />}
      <div style={{ marginLeft: !hideSidebarPages ? '270px' : 'auto', width: '100%' }}>
        {children}
      </div>
    </div>
  );
};

const AppRoutes = () => {
  return (
    <Routes>
      {/* 🔁 Rediriger "/" vers "/login" */}
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/clients" element={<Clients />} />
      <Route path="/fournisseurs" element={<Fournisseurs />} />
    
      <Route path="/cheque" element={<ChequeForm />} />
      <Route path="/banque" element={<PositionEditor />} />
    </Routes>
  );
};

const App = () => {
  return (
    <Router>
      <Layout>
        <AppRoutes />
      </Layout>
    </Router>
  );
};

export default App;
